// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__hJWQv","tab":"Tabs_tab__WBSZE","btn":"Tabs_btn__Blqo6","active":"Tabs_active__uaUl3","body":"Tabs_body__GhvEp"};